import React from 'react';
import TwoThreeRows from "../layouts/TwoThreeRows/TwoThreeRows";
import ContentPanel from "../components/ContentPanel/ContentPanel";
import Skeleton from "../components/Skeleton/Skeleton";
import ToolsWidget from "../components/ToolsWidget/ToolsWidget";
import BlankComponent from "../components/BlankComponent/BlankComponent";
import store from "../store";
import {Helmet} from "react-helmet";

const learn = () => {
  return (
    <BlankComponent>
        <Helmet>
            {
                store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row, index) => {
                    return row.rowTitle === "Learn" ? <meta key={index} name="description" content={row.content['seo-description']}/> : null
                }) : null
            }
        </Helmet>
      <TwoThreeRows
        rows={3}

        mainPanel={
          <ContentPanel
            skeleton={<Skeleton type="MAIN_PANEL"/>}
            errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
            templateUrl="./content/learn/page-components/text-block/learn-landing-heading.html"
          />
        }

        contentPanel1={
          <ContentPanel
            skeleton={<Skeleton type="CONTENT_PANEL"/>}
            errorTemplate={<Skeleton type="CONTENT_PANEL_ERROR"/>}
            templateUrl="./content/learn/page-components/article/learn-landing/learn-landing-tile-1.html"
          />
        }

        contentPanel2={
          <ContentPanel
            skeleton={<Skeleton type="CONTENT_PANEL"/>}
            errorTemplate={<Skeleton type="CONTENT_PANEL_ERROR"/>}
            templateUrl="./content/learn/page-components/article/learn-landing/learn-landing-tile-2.html"
          />
        }

        contentPanel3={
          <ContentPanel
            skeleton={<Skeleton type="CONTENT_PANEL"/>}
            errorTemplate={<Skeleton type="CONTENT_PANEL_ERROR"/>}
            templateUrl="./content/learn/page-components/article/learn-landing/learn-landing-tile-3.html"
          />
        }
      />
      <div className="wrapper mb36 mt25">
        <ToolsWidget/>
      </div>
    </BlankComponent>
  )
};

export default learn;



// WEBPACK FOOTER //
// ./src/pages/Learn.js